import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type PeriodoTimelineToggle = "12m" | "24m" | "tudo";

/** Alternador de janela da timeline (12 meses / 24 meses / tudo). Compartilhado entre
 *  a timeline do freelancer e a da agência — mesmos três recortes, mesma UI. */
export function PeriodoToggle({
  periodo,
  onChange,
}: {
  periodo: PeriodoTimelineToggle;
  onChange: (periodo: PeriodoTimelineToggle) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      size="sm"
      variant="outline"
      value={periodo}
      onValueChange={(novoPeriodo) => {
        if (novoPeriodo) onChange(novoPeriodo as PeriodoTimelineToggle);
      }}
    >
      <ToggleGroupItem value="12m" aria-label="Últimos 12 meses">
        12 meses
      </ToggleGroupItem>
      <ToggleGroupItem value="24m" aria-label="Últimos 24 meses">
        24 meses
      </ToggleGroupItem>
      <ToggleGroupItem value="tudo" aria-label="Histórico completo">
        Tudo
      </ToggleGroupItem>
    </ToggleGroup>
  );
}

export default PeriodoToggle;
